import React from 'react'
import '../../../App.css'
import LeadershipLinks from '../LeadershipLinks';
import ImageComponent from '../../ImageComponent';

function DanVoss() {
    return (
      <div className='bio-pages main-grid-container'>
      <div className='main-grid-item'>
    <LeadershipLinks/>
    </div>
          <div className='main narrow-grid'>
             <div className='bio-img-wrapper'>
              <ImageComponent src={require('../../../img/dan_voss_bio_portrait_1000px.jpg')}/>
               {/* <img src={require('../../../img/dan_voss_bio_portrait_1000px.jpg')} alt='larry loden portrait' /> */}
             </div>
            <h1 className='bio-header'>Dan Voss</h1>
            {/* <h2 className='bio-subheader'>Elder</h2> */}
            <p> 
            Dan Voss has lived in Texas most of his life growing up in the Clear Lake
            area of Houston and moving to the central Texas area in 1991. He was
            blessed with godly parents and saved by Gods grace during his teen years.
            He has been a member of Grace Community Fellowship since 2012 and
            served as a Deacon for several years until becoming an Elder in November
            2025.<br/><br/>
            Dan has been involved since the 1990’s in short term medical missions in
            Mexico, Guatemala, and most recently Honduras. He is active in leading
            short-term missions, discipling and evangelism. He particularly has a
            passion for discipling young men.<br/><br/>
            Dan met Kathy, his wife of 44 years at Texas A&amp;M, and they were married
            just before he started medical school at UTMB Galveston. He had a 36-
            year career as a family doctor serving the Georgetown area for over 30 of
            those years. Dan retired from medicine in 2023 to devote his time to cattle
            ranching and other interests. Dan and Kathy live on the ranch near Jarrell
            and are blessed to have 4 children and 11 grandchildren.
            </p>
          </div>
        </div>
      )
    }

export default DanVoss
